export const BAYER_BASE_URL = process.env.VUE_APP_BAYER_BASE_URL
export const IDT_BASE_URL = process.env.VUE_APP_IDT_BASE_URL
// 是否是本地开发环境
export const IS_LOCAL = process.env.VUE_APP_MODE === 'local'
// 认证信息
export const AUTH_CONFIG = {
  'http://localhost:8080': {
    accessCode: 127,
    scope: 'wecom',
    result_type: 'encodeurl',
  },
  'https://uat-bayer.imagedt.com': {
    accessCode: 127,
    scope: 'wecom',
    result_type: 'encodeurl',
  },
  'https://uat-xdisplay.bayer.cn': {
    accessCode: 127,
    scope: 'wecom',
    result_type: 'encodeurl',
  },
  'https://bayer.imagedt.com': {
    accessCode: 125,
    scope: 'wecom',
    result_type: 'encodeurl',
  },
  'https://xdisplay.bayer.cn': {
    accessCode: 125,
    scope: 'wecom',
    result_type: 'encodeurl',
  },
}

// 本地调试用的认证信息
// export const AUTH_CWID = 'GNHQL'
// export const AUTH_CWID = 'EFOUP'
export const AUTH_CWID = 'EFXQR'

// 企微认证接口
export const WX_AUTH_URL = [
  {
    wx: 'https://wecomapi-q.bayer.cn',
    idt: 'http://localhost:8080',
  },
  {
    wx: 'https://wecomapi-q.bayer.cn',
    idt: 'https://uat-bayer.imagedt.com',
  },
  {
    wx: 'https://wecomapi-q.bayer.cn',
    idt: 'https://uat-xdisplay.bayer.cn',
  },
  { wx: 'https://wecomapi.bayer.cn', idt: 'https://bayer.imagedt.com' },
  { wx: 'https://wecomapi.bayer.cn', idt: 'https://xdisplay.bayer.cn' },
]
